import api from '@/services/api'

export default {
  getAllProducts(page, description = '') {
    return api.get(`/products?page=${page}&description=${description}&all=true`)
  },

  getProductsByBanner(bannerId) {
    return api.get(`/products?banner_id=${bannerId}`)
  },

  createProduct(data) {
    return api.post('/products', data)
  },

  updateProduct(id, data) {
    return api.put(`/products/${id}`, data)
  },

  saveProduct(data) {
    if (data._id) {
      return api.put(`/products/${data._id}`, data);
    } else {
      return api.post('/products', data);
    }
  },

  getProduct(id) {
    return api.get('/products/' + id)
  },

  removeProduct(id) {
    return api.delete('/products/' + id)
  },

  uploadImage(id, formData) {
    return api.post(`/products/${id}/images?form=true`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  removeImage(productId, imageId) {
    return api.delete(`/products/${productId}/images/${imageId}`)
  },

  getCategories(page) {
    return api.get(`/categories?page=${page}`);
  },

  getCategory(id) {
    return api.get(`/categories/${id}`);
  },

  removeCategory(id) {
    return api.delete(`/categories/${id}`);
  },

  saveCategory(data) {
    if (data._id) {
      return api.put(`/categories/${data._id}`, data);
    } else {
      return api.post('/categories', data);
    }
  },

  uploadCategoryImage(formData) {
    return api.post('/categories/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  getAllComplements() {
    return api.get('/product-complements?all=true')
  },
  getComplements(page, description = '') {
    return api.get(`/product-complements?page=${page}&description=${description}&all=true`)
  },
  createComplement(data) {
    return api.post('/product-complements', data)
  },
  updateComplement(data) {
    return api.put(`/product-complements/${data._id}`, data)
  },
  removeComplement(id) {
    return api.delete('/product-complements/' + id)
  },

  getAllComplementsGroups(page, description = '') {
    return api.get(`/product-complements/group?page=${page}&description=${description}&all=true`)
  },
  createComplementGroup(data) {
    return api.post('/product-complements/group', data)
  },
  updateComplementGroup(data) {
    return api.put(`/product-complements/group/${data._id}`, data)
  },
  removeComplementGroup(id) {
    return api.delete('/product-complements/group/' + id)
  },

  getProductsSales(page, description = '') {
    return api.get(`/reports/products-sales?page=${page}&description=${description}`)
  },

  downloadProductSalesReport() {
    return api.get(`/reports/products-sales?download=true`)
  }
}